import ProfileList from '@containers/profile/ProfileList';
import { useEffect } from 'react';

const ProfileListPage = () => {
  useEffect(() => {}, []);

  return <ProfileList />;
};

export default ProfileListPage;
